import React from 'react';
import * as styles from './styles.scss';

const Section = ({ className, children, ...props }) => (
    <div className={`${styles.section}${className ? ` ${className}` : ''}`} {...props}>
        {children}
    </div>
);

export default Section;
